module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"bundle_text":"Offer discounted price for bundle of item","coupons_text":"Generate coupon codes for your customers"},"id":{"bundle_text":"Menawarkan harga diskon untuk Bundle item","coupons_text":"Buatkan kode kupon untuk pelanggan kamu"}}')
  delete Component.options._Ctor
}
